import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { SharedPanel } from './SharedPanel';
const PanelServiceContext = React.createContext(Promise.reject);
export const usePanel = () => React.useContext(PanelServiceContext);
export const PanelServiceProvider = ({ children }) => {
    const [dialogState, setDialogState] = React.useState(null);
    const awaitingPromiseRef = React.useRef();
    const openConfirmation = (options) => {
        setDialogState(options);
        return new Promise((resolve, reject) => {
            awaitingPromiseRef.current = { resolve, reject };
        });
    };
    const handleClose = () => {
        if (dialogState &&
            dialogState.catchOnCancel &&
            awaitingPromiseRef.current) {
            awaitingPromiseRef.current.reject();
        }
        setDialogState(null);
    };
    const handleSubmit = () => {
        if (awaitingPromiseRef.current) {
            awaitingPromiseRef.current.resolve();
        }
        setDialogState(null);
    };
    return (_jsxs(_Fragment, { children: [_jsx(PanelServiceContext.Provider, { value: openConfirmation, children: children }), _jsx(SharedPanel, Object.assign({ open: Boolean(dialogState), onSubmit: handleSubmit, onClose: handleClose }, dialogState))] }));
};
//# sourceMappingURL=PanelService.js.map